/*
 *   File : primary.js
 *   Author : https://evoqins.com
 *   Description : CTA component
 *   Integrations : NA
 *   Version : 1.0.0
 */

import React, { memo } from "react";
import "../../Style/Components/button.scss";
import Icon from "../icons";

const Button = (props) => {
  return (
    <button
      className={`custom-button transition-all ${props.ClassName} ${
        props.disabled ? " opacity-50" : " "
      }`}
      style={{ position: "relative" }}
      data-bs-toggle={props.toggle}
      data-bs-target={props.target}
      data-bs-cancel={props.cancel}
      data-bs-dismiss={props.dismiss}
      disabled={props.disabled}
      id={props.id}
      onClick={(e) => {
        if (props.loading) return;
        props.onPress(e);
      }}
    >
      <span style={{ visibility: props.loading ? "hidden" : "visible" }}>
        {props.type === 2 ? (
          <>
            {props.name}
            {props.icon && (
              <Icon
                icon={props.icon}
                size={props.size ? props.size : "20px"}
                className="ms-1"
              />
            )}
          </>
        ) : (
          <>
            {props.icon && (
              <Icon
                icon={props.icon}
                size={props.size ? props.size : "20px"}
                className={props.name ? "me-2" : "m-0"}
              />
            )}
            {props.name}
          </>
        )}
      </span>
      {props.loading && (
        <span
          style={{
            position: "absolute",
            left: "50%",
            top: "50%",
            transform: "translate(-50%, -50%)",
          }}
        >
          <span
            className="spinner-border spinner-border-sm"
            aria-hidden="true"
          ></span>
        </span>
      )}
    </button>
  );
};

Button.defaultProps = {
  onPress: () => {},
  className: null,
  id: null,
  name: null,
  icon: null,
};

export default memo(Button);
